import MascotImage from 'img/mascot/maskot-looks-smile-dark.png';
import NewUnsubImage from 'img/newUnsubPoll/newUnsubPoll.png';
import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { updatedUnsubScreensEnabled } from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewUnsub';
import { getReasons, Reasons } from 'reactApp/ui/PollPopup/PollPopup.constants';
import styles from 'reactApp/ui/PollPopup/PollPopup.css';
import { SelectableButton } from 'reactApp/ui/PollPopup/SelectableButton';

export const PollContent = memo(
    ({
        onComment,
        onChoice,
        choiceId,
        isPhone,
        comment,
    }: {
        onComment(comment: string): void;
        onChoice(id: string): void;
        choiceId: string;
        comment: string;
        isPhone: boolean;
    }) => {
        const reasons = useMemo(() => getReasons(isPhone), [isPhone]);

        const rootRef = useRef<HTMLInputElement | null>(null);

        const isOtherSelected = choiceId === Reasons.OTHER_ID;

        const handleOnComment = useCallback(
            (event: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = event.target;
                onComment(value);
            },
            [onComment]
        );

        const getImage = useCallback(() => {
            // tempexp_19963-start
            if (updatedUnsubScreensEnabled) {
                return NewUnsubImage;
            }
            // tempexp_19963-end
            return MascotImage;
        }, []);

        useEffect(() => {
            if (isOtherSelected && isPhone) {
                rootRef?.current?.scrollIntoView();
            }
        }, [isOtherSelected, isPhone]);

        const getTitle = useCallback(() => {
            if (updatedUnsubScreensEnabled) {
                return `Почему решили отключить${isPhone ? '\u00A0' : ' '}автоплатёж?`;
            }
            return 'Почему вы решили отключить автоплатёж?';
        }, []);

        return (
            <div className={isPhone ? styles.content_phone : ''}>
                <img className={updatedUnsubScreensEnabled && !isPhone ? styles.imageBig : styles.image} src={getImage()} />
                <div className={updatedUnsubScreensEnabled && !isPhone ? styles.titleNew : styles.title}>{getTitle()}</div>
                <div className={styles.buttons}>
                    {reasons.map((reason) => (
                        <SelectableButton
                            key={reason}
                            title={reason}
                            onClick={onChoice}
                            isSelected={reason === choiceId}
                            isPhone={isPhone}
                        />
                    ))}
                    {isOtherSelected && (
                        <input
                            ref={rootRef}
                            onChange={handleOnComment}
                            autoComplete="off"
                            placeholder="Ваш комментарий"
                            value={comment}
                            type="text"
                            id="comment"
                        />
                    )}
                </div>
            </div>
        );
    }
);

PollContent.displayName = 'PollContent';
